import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

/** Old office Job Records URL. The form now lives on Aftercare. */
const JobReviewPage: React.FC = () => {
  const { projectId = '' } = useParams<{ projectId: string }>();
  return <Navigate to={`/projects/${encodeURIComponent(projectId)}/workspace/aftercare`} replace />;
};

export default JobReviewPage;
